import { render, staticRenderFns } from "./attachment.dialog.vue?vue&type=template&id=f6f3b4bc"
import script from "./attachment.dialog.vue?vue&type=script&lang=js"
export * from "./attachment.dialog.vue?vue&type=script&lang=js"
import style0 from "./attachment.dialog.vue?vue&type=style&index=0&id=f6f3b4bc&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports